import { MessageCenter } from "@/components/messaging/MessageCenter";
import { AppNavbar } from "@/components/layout/AppNavbar";

export default function Messages() {
  return (
    <div className="min-h-screen bg-background">
      <AppNavbar />
      <div className="container mx-auto px-4 py-8">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-foreground">Messages</h1>
          <p className="text-muted-foreground mt-2">
            Communicate with the certification team and manage your messages
          </p>
        </div>
        
        <MessageCenter />
      </div>
    </div>
  );
}